import "./hr.css";
const Hr = () => {
  return (
    <div className="left-side-hr">
      <h4>HR</h4>
    </div>
  );
};

export default Hr;
